import { render, staticRenderFns } from "./fullscreen-error.component.vue?vue&type=template&id=d495ace2&"
import script from "./fullscreen-error.component.vue?vue&type=script&lang=ts&"
export * from "./fullscreen-error.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports